module.exports = __webpack_public_path__ + "static/14_retro-journey-mapping.bb7d8a70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/14_retro-journey-mapping.jpg
// module id = 486
// module chunks = 110568472390859